/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import {
  InputV2,
  TipoEquipamentoSelectV2,
  TrueFalseSelectV2,
  DatePickerV2,
  ArquivoContainerV2,
  CreatableSelectV2,
} from '../../../components/v2';
import { fetchEquipamentoModelos } from '../../../helpers/equipamentoModelos';

const InformacaoBasicaTab = ({ values, setValues, errors, handleChange }) => {
  const [modeloOptions, setModeloOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const tipo = values.tipoEquipamento;
    if (!tipo) {
      setModeloOptions([]);
      return undefined;
    }
    (async () => {
      try {
        const options = await fetchEquipamentoModelos(tipo);
        if (!cancelled) setModeloOptions(options);
      } catch (e) {
        if (!cancelled) setModeloOptions([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [values.tipoEquipamento]);

  const modeloNome = String(values.modelo || '').trim();
  const modeloValue = useMemo(() => {
    if (!modeloNome) return null;
    const found = modeloOptions.find((option) => option.label === modeloNome);
    return found || { value: modeloNome, label: modeloNome };
  }, [modeloNome, modeloOptions]);

  const opcoesModelo = useMemo(() => {
    if (!modeloNome) return modeloOptions;
    if (modeloOptions.some((option) => option.label === modeloNome)) {
      return modeloOptions;
    }
    return [{ value: modeloNome, label: modeloNome }, ...modeloOptions];
  }, [modeloNome, modeloOptions]);

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TipoEquipamentoSelectV2
          showEmpty
          isRequired
          onChange={(tipoEquipamento) => setValues({
            ...values,
            tipoEquipamento,
            modelo: '',
          })}
          value={values.tipoEquipamento}
          error={!!(errors && errors.tipoEquipamento)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <CreatableSelectV2
          label="Modelo"
          isRequired
          disabled={!values.tipoEquipamento}
          error={!!(errors && errors.modelo)}
          options={opcoesModelo}
          value={modeloValue}
          placeholder={values.tipoEquipamento ? 'Selecione ou crie' : 'Selecione o tipo'}
          onChange={(option) => setValues({
            ...values,
            modelo: option && option.label ? String(option.label).trim() : '',
          })}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <InputV2
          label="Num. Patrimônio"
          name="numPatrimonio"
          onChange={handleChange}
          value={values.numPatrimonio || ''}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <InputV2
          label="Num. Série"
          name="numSerie"
          onChange={handleChange}
          value={values.numSerie || ''}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TrueFalseSelectV2
          error={!!(errors && errors.ativo)}
          isRequired
          label="Ativo"
          name="ativo"
          onChange={handleChange}
          value={values.ativo}
        />
      </Grid>
      {values.tipoEquipamento === 'DRONE' && (
        <>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Num. Série Camera"
              name="numSerieCamera"
              onChange={handleChange}
              value={values.numSerieCamera || ''}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Código SISANT"
              name="codigoSisant"
              onChange={handleChange}
              value={values.codigoSisant || ''}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <DatePickerV2
              label="Vencimento SISANT"
              onChange={(data) => setValues({ ...values, validoAteSisant: data })}
              value={values.validoAteSisant}
              showInput
            />
          </Grid>
        </>
      )}
      {['CELULAR', 'DRONE', 'RADIO'].includes(values.tipoEquipamento) && (
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Código ANATEL"
            name="codigoAnatel"
            onChange={handleChange}
            value={values.codigoAnatel || ''}
          />
        </Grid>
      )}
      {values.tipoEquipamento === 'DRONE' && (
        <Grid size={{ xs: 12, sm: 8 }}>
          <InputV2
            label="Apólice de seguro"
            name="numApoliceSeguro"
            onChange={handleChange}
            value={values.numApoliceSeguro || ''}
          />
        </Grid>
      )}
      {values.id && (
        <>
          <Grid size={{ xs: 12, sm: 6 }}>
            <InputV2
              label="Último Repasse/Colaborador"
              disabled
              value={values.ultimoRepasse || ''}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Criado Por"
              disabled
              value={values.criadoPorName || ''}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Data Inclusão"
              disabled
              value={values.dataInclusao || ''}
            />
          </Grid>
        </>
      )}
      <Grid size={{ xs: 12 }}>
        <InputV2
          label="Outras informações"
          name="informacao"
          onChange={handleChange}
          value={values.informacao || ''}
          rows={3}
          multiline
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <ArquivoContainerV2
          arquivos={values.arquivos}
          onSave={(arquivos) => setValues({ ...values, arquivos })}
        />
      </Grid>
    </Grid>
  );
};

InformacaoBasicaTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

export default InformacaoBasicaTab;
